import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../assets/icons/legacy/video_deactive.svg';
export const DisabledCamera = () => {
    return (<>
      <Icon />
      <FormattedMessage id="notification.video-deactive{linebreak}" tagName="p" values={{
            linebreak: <br />,
        }}/>
    </>);
};
